import api from "./api";
import History from "@/model/history";

class HistoryApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async index() {
    const response = await this.post('histories');
    if (!response?.data?.context.length) {
      return [];
    }
    const histories = JSON.parse(response.data.context).data.orders;
    const result = []

    histories.map(value => {
      result.push(value)
    })

    return result.map(item => {
      return new History(item)
    })
  }
}

export default new HistoryApi();
